exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.company-video iframe { \r\n  width: 100% !important; \r\n  margin-bottom: 20px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6195060c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/company-video.vue
// module id = 621
// module chunks = 0